module.exports = __webpack_public_path__ + "img/new-object-ballons.7ac19ad5.png";